// This file is generated.
export const version = '1.83.0'
